import { mode } from "@chakra-ui/theme-tools";
var parts = ["text", "icon"];

function baseStyleText(props) {
  return {
    color: mode("red.500", "red.300")(props),
    mt: 2,
    fontSize: "sm"
  };
}

function baseStyleIcon(props) {
  return {
    mr: "0.5em",
    color: mode("red.500", "red.300")(props)
  };
}

var baseStyle = function baseStyle(props) {
  return {
    text: baseStyleText(props),
    icon: baseStyleIcon(props)
  };
};

export default {
  parts: parts,
  baseStyle: baseStyle
};